module.exports = __webpack_public_path__ + "static/media/domectic-disable.16e700c0.svg";